export default __webpack_public_path__ + "static/media/incomming_call.97cbb0f2.png";